<template>
  <div :class="bottomTabClass">
    <div class="play-menu-container">
      <ul @click.prevent="changeTab">
        <li v-for="(tab, index) in getTabListBySection" :class="tab.type + (currentTab === tab.type ? ' on' : '')"
            :data-type="tab.type" :key="'bottom_tab' + index">
          {{tab.title}}
        </li>
      </ul>
      <portal-target name="play-filter" class="sub-filter"></portal-target>
    </div>
    <div class="play-list-container" :style="{ 'padding-bottom' : (isHomeShoppingChannel ? '35px' : '0px') }">
      <div class="all-content" v-if="currentTab === 'all'">
        <all-content-list :section="section"
                          :content-info="contentInfo" :key="'tab-allcontent_' + $route.fullPath"></all-content-list>
      </div>
      <div class="content-tab-container" v-if="currentTab === 'recommend'">
        <recommend-content-list :content-info="contentInfo" :section="section" :key="'tab-recommend_'+ $route.fullPath"></recommend-content-list>
      </div>
      <div class="content-tab-container" v-if="currentTab === 'voucher'">
        <voucher-content-list :content-info="contentInfo"
                              :section="section"
                              :key="'bottom-voucher-list_' + $route.fullPath"
        ></voucher-content-list>
      </div>
    </div>
  </div>
</template>
<script>
import AllContentList from '@/components/play/bottom-tab/AllContentList'
import VueSticky from 'vue-sticky'
import RecommendContentList from '@/components/play/bottom-tab/RecommendContentList'
import VoucherContentList from '@/components/play/bottom-tab/VoucherContentList'
import CheckOn from '@/assets/svg/common/ic_check_on_p.svg'
import CheckOff from '@/assets/svg/common/ic_check_off.svg'
import Reload from '@/assets/svg/common/ic_replay.svg'
import { EventBus } from '@/components/eventbus/EventBus'
import { sortBy } from 'lodash'
export default {
  name: 'BottomTabContainer',
  props: { contentInfo: { type: Object }, isHomeShoppingChannel: { type: Boolean } },
  data () {
    return {
      section: '',
      currentTab: 'all',
      tabList: [
        {
          title: '전체회차',
          type: 'all',
          order: 0,
          visible: ['vod']
        },
        {
          title: '전체채널',
          type: 'all',
          order: 0,
          visible: ['live']
        },
        {
          title: '동일회차 TV컷',
          type: 'all',
          order: 0,
          visible: ['clip']

        },
        {
          title: '구매정보',
          type: 'voucher',
          order: 2,
          visible: ['movie']
        },
        {
          title: '추천',
          type: 'recommend',
          order: 1,
          visible: ['vod', 'movie', 'live', 'clip']
        }
      ]
    }
  },
  components: {
    VoucherContentList,
    RecommendContentList,
    AllContentList,
    CheckOn,
    CheckOff,
    Reload
  },
  directives: {
    VueSticky
  },
  methods: {
    changeTab (e) {
      if (e.target.tagName.toUpperCase() === 'LI') {
        this.currentTab = e.target.dataset.type
      }
    }
  },
  computed: {
    getTabListBySection () {
      const currentSectionTabs = this.tabList.filter((tab) => {
        return tab.visible.indexOf(this.section) > -1
      })
      return sortBy(currentSectionTabs, ['order'])
    },
    bottomTabClass () {
      return 'bottom-tab-container ' + this.currentTab
    }
  },
  mounted () {
    const defaultTab = this.getTabListBySection[0]
    this.currentTab = defaultTab.type
    EventBus.$on('go-recommend', () => {
      this.changeTab({
        'target' : {
          'tagName' : 'li',
          'dataset' : {
            'type' : 'recommend'
          }
        }
      })
    })
  },
  created () {
    this.section = this.$route.params.section
  }
}
</script>
<style scoped>
  .play-list-container,
  .content-tab-container {
    background-color: #101010;
    min-height: 221px;
  }
  .play-menu-container {
    position: relative !important;
    width: 100%;
    top: 0;
    z-index: 1;
  }
  .play-menu-container .sub-filter {
    width: 100%;
    background-color: #101010;
  }

  @media screen and (min-width: 768px){
    .play-menu-container {
      top: 0;
    }
  }
  /*.filter-header span {*/
    /*width: 100%;*/
    /*height: 60px;*/
    /*background-color: #f7f7f7;*/
  /*}*/
  /*.refresh-txt {*/
    /*width: 100%;*/
    /*background-color: #f7f7f7;*/
  /*}*/
</style>
